(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sugarhalo-product-feature-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindFeatureTabs = (root) => {
      if (!root || root.dataset.shFeatureTabsBound === 'true') return;

      const panels = Array.from(root.querySelectorAll('[data-sh-feature-tab-panel]'));
      const triggers = Array.from(root.querySelectorAll('[data-sh-feature-tab-trigger]'));
      if (!panels.length || !triggers.length) return;

      root.dataset.shFeatureTabsBound = 'true';

      let activeIndex = Math.max(0, panels.findIndex((panel) => panel.classList.contains('is-active')));
      let timer = null;
      const interval = Number(root.dataset.interval) || 4500;
      const autoplay = root.dataset.autoplay === 'true';

      const setActive = (index) => {
        activeIndex = (index + panels.length) % panels.length;

        panels.forEach((panel, panelIndex) => {
          const isActive = panelIndex === activeIndex;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        triggers.forEach((trigger, triggerIndex) => {
          const isActive = triggerIndex === activeIndex;
          trigger.classList.toggle('is-active', isActive);
          trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      };

      const start = () => {
        if (!autoplay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        window.clearInterval(timer);
        timer = window.setInterval(() => setActive(activeIndex + 1), interval);
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          setActive(Number(trigger.dataset.index) || 0);
          start();
        });
      });

      root.addEventListener('mouseenter', () => window.clearInterval(timer));
      root.addEventListener('mouseleave', start);
      setActive(activeIndex);
      start();
    };

    document.querySelectorAll('[data-sh-feature-tabs]').forEach(bindFeatureTabs);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-sh-feature-tabs]').forEach(bindFeatureTabs);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sugarhalo-user-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initGuide = (root) => {
      if (!root || root.dataset.guideReady === 'true') return;

      const panels = Array.from(root.querySelectorAll('[data-guide-page]'));
      const links = Array.from(root.querySelectorAll('[data-guide-link]'));
      const prev = root.querySelector('[data-guide-prev]');
      const next = root.querySelector('[data-guide-next]');
      const prevLabel = root.querySelector('[data-guide-prev-label]');
      const nextLabel = root.querySelector('[data-guide-next-label]');
      const layout = root.querySelector('.sh-user-guide__layout');

      if (!panels.length) return;

      root.dataset.guideReady = 'true';
      root.classList.add('is-paged');

      const aliases = {
        'setup-guide': 'whats-in-the-box',
        'getting-started-overview': 'whats-in-the-box',
        'what-you-need': 'whats-in-the-box',
        'first-power-on': 'power-on',
        'setup-walkthrough': 'set-up-your-cgm',
        'dexcom-setup': 'dexcom-cgm-setup',
        'librelinkup-setup': 'librelinkup-cgm-setup',
        'nightscout-setup': 'nightscout-cgm-setup',
        'troubleshooting': 'device-wont-power-on',
        'troubleshooting-overview': 'device-wont-power-on',
        'feature-list': 'accessing-web-portal',
        'detailed-feature-list': 'accessing-web-portal',
        'feature-requests': 'other-settings'
      };
      const resolveId = (id) => aliases[id] || id;
      const findIndex = (id) => panels.findIndex((panel) => panel.id === id);
      const panelTitle = (panel) => panel?.dataset.guideTitle || panel?.querySelector('h2')?.textContent?.trim() || '';

      const updatePager = (index) => {
        const previousPanel = panels[index - 1];
        const nextPanel = panels[index + 1];

        if (prev) {
          if (previousPanel) {
            prev.href = `#${previousPanel.id}`;
            prev.classList.remove('is-disabled');
            prev.removeAttribute('aria-disabled');
            prev.removeAttribute('tabindex');
            if (prevLabel) prevLabel.textContent = panelTitle(previousPanel);
          } else {
            prev.href = `#${panels[index].id}`;
            prev.classList.add('is-disabled');
            prev.setAttribute('aria-disabled', 'true');
            prev.setAttribute('tabindex', '-1');
            if (prevLabel) prevLabel.textContent = 'Start of guide';
          }
        }

        if (next) {
          if (nextPanel) {
            next.href = `#${nextPanel.id}`;
            next.classList.remove('is-disabled');
            next.removeAttribute('aria-disabled');
            next.removeAttribute('tabindex');
            if (nextLabel) nextLabel.textContent = panelTitle(nextPanel);
          } else {
            next.href = `#${panels[index].id}`;
            next.classList.add('is-disabled');
            next.setAttribute('aria-disabled', 'true');
            next.setAttribute('tabindex', '-1');
            if (nextLabel) nextLabel.textContent = 'End of guide';
          }
        }
      };

      const showPanel = (id, options = {}) => {
        const resolvedId = resolveId(id);
        const index = findIndex(resolvedId);
        if (index < 0) return;

        panels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.classList.toggle('is-active', active);
          panel.toggleAttribute('hidden', !active);
        });

        root.querySelectorAll('.sh-user-guide__nav-group').forEach((group) => {
          group.classList.remove('is-active-group');
        });

        links.forEach((link) => {
          const active = link.hash === `#${resolvedId}`;
          link.classList.toggle('is-active', active);
          if (active) {
            link.setAttribute('aria-current', 'true');
            const group = link.closest('.sh-user-guide__nav-group');
            if (group) {
              group.open = true;
              group.classList.add('is-active-group');
            }
          } else {
            link.removeAttribute('aria-current');
          }
        });

        updatePager(index);

        if (options.updateHash && window.location.hash !== `#${resolvedId}`) {
          window.history.pushState(null, '', `#${resolvedId}`);
        }

        if (options.scroll && layout) {
          layout.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        if (options.focus) {
          const heading = panels[index].querySelector('h2');
          if (heading) {
            heading.setAttribute('tabindex', '-1');
            heading.focus({ preventScroll: true });
          }
        }
      };

      const handleClick = (event) => {
        const trigger = event.currentTarget;
        const id = trigger.hash ? trigger.hash.slice(1) : '';
        if (findIndex(resolveId(id)) < 0) return;
        event.preventDefault();
        showPanel(id, { updateHash: true, scroll: true, focus: true });
      };

      links.forEach((link) => link.addEventListener('click', handleClick));
      [prev, next].forEach((link) => {
        if (link) link.addEventListener('click', handleClick);
      });

      window.addEventListener('hashchange', () => {
        const id = window.location.hash.slice(1);
        if (findIndex(resolveId(id)) >= 0) {
          showPanel(resolveId(id), { scroll: true, focus: true });
        }
      });

      const initialHash = resolveId(window.location.hash.slice(1));
      const initialId = findIndex(initialHash) >= 0 ? initialHash : panels[0].id;
      showPanel(initialId, { scroll: window.location.hash.length > 1 });
    };

    const initAllGuides = () => {
      document.querySelectorAll('[data-sh-user-guide]').forEach(initGuide);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllGuides);
    } else {
      initAllGuides();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initGuide(event.target.querySelector('[data-sh-user-guide]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
